import { createReducer, on } from '@ngrx/store';
import { CompanyActions } from './company.actions';
import { CompanyItem } from '@core/interface/company';
import { Pagination } from '@core/interface/core';

export const companyFeatureKey = 'company';

export interface CompanyState {
  companies: CompanyItem[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: CompanyState = {
  companies: [],
  isLoading: true,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const CompanyReducer = createReducer(
  initialState,
  on(CompanyActions.loadCompanies, (state) => ({ ...state, isLoading: true })),
  on(CompanyActions.loadCompaniesSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    companies: data,
    isLoading: false,
    loadError: null,
  })),
  on(CompanyActions.loadCompaniesFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(CompanyActions.addCompanySuccess, (state, { data }) => ({
    ...state,
    companies: [...state.companies, data],
    addEditError: null,
  })),
  on(CompanyActions.addCompanyFailure, (state, error) => ({
    ...state,
    addEditError: error,
  })),
  on(CompanyActions.updateCompanySuccess, (state, { data }) => ({
    ...state,
    companies: state.companies.map((company) =>
      data.id == company.id ? data : company
    ),
    addEditError: null,
  })),
  on(CompanyActions.updateCompanyFailure, (state, { error }) => ({
    ...state,
    addEditError: error,
  })),
  on(CompanyActions.deleteCompanySuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    companies: state.companies.filter((company) => company.id !== id),
  })),
  on(CompanyActions.deleteCompanyFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(CompanyActions.deleteCompany, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(CompanyActions.resetDeleteStatus, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(CompanyActions.resetCompanies, (state) => ({
    ...state,
    pagination: {
      current_page: 0,
      last_page: 0,
      per_page: 10,
      total: 0,
    },
    companies: [],
    isLoading: false,
  }))
);
